import React from "react";
import PropTypes from "prop-types";
import withStyles from "components/with-styles";
import styles from "./styles/autocomplete-suggestion-part.css.js";

const Part = ({ part, classes }) => {
  return part.highlight ? (
    <span className={classes.highlighted_part}>{part.text}</span>
  ) : (
    <strong className={classes.part}>{part.text}</strong>
  );
};

Part.propTypes = {
  /**
   * Elemento paginado en un objeto con la colección y el total
   **/
  part: PropTypes.object,
};

export default withStyles(styles)(Part);
